module.exports = __webpack_public_path__ + "img/types-title-noise.png?b3a6e44b7aa90b0260e9522fec4768e9";